import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class CancelError extends Error {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isCancelled", true);
  }
}
const CANCEL_ERROR = new CancelError('Promise is cancelled');
export class CancellablePromise {
  constructor(promise) {
    _defineProperty(this, "cancelInternal", () => {
      // Default throws an error as this should never happen
      throw new Error('Programming error, cancelling promise is not properly rejected');
    });
    _defineProperty(this, "promise", () => this.cancellablePromiseInternal);
    _defineProperty(this, "cancel", () => this.cancelInternal());
    this.cancellablePromiseInternal = Promise.race([promise, new Promise((_, reject) => {
      this.cancelInternal = () => reject(CANCEL_ERROR);
    })]);
  }
  static from(promise) {
    return new CancellablePromise(promise);
  }
}